/*
 * File: catalog-wizard.component.ts                                           *
 * Project: catalog-cloud                                                      *
 * File Created: Monday, 24th January 2022 09:53:03                            *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 14:40:19                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */




import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CatalogService } from '../../../services/catalog.service';
import { Stepper } from 'primeng/stepper';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-catalog-wizard',
  templateUrl: './catalog-wizard.component.html',
  styleUrls: ['./catalog-wizard.component.scss'],
})
export class CatalogWizardComponent implements OnInit {
  @Input() id: string;
  @Input() data: any;
  @ViewChild('stepper') private stepWizzard: Stepper;
  @Output() closeForm: EventEmitter<void> = new EventEmitter<void>();

  idCatalog: string;
  catalogInfoStep: FormGroup; //Formulario del paso actual

  catalogInfoStepLabel: string = 'Datos del catálogo';
  catalogChildForm: FormGroup;
  checkDifferencesStep: FormGroup;
  checkDifferencesStepLabel: string = 'Sincronización';
  syncStep: FormGroup;
  syncStepLabel: string = 'Sincronizar';
  catalogForm: FormGroup;
  activeIndex: number = 0;

  catalogIsValid: boolean = false;
  preSyncIsValid: boolean = false;
  syncIsValid: boolean = false;

  steps = [
    {
      label: 'Datos del catálogo',
      isValid: false,
    },
    {
      label: 'Sincronización',
      isValid: false,
    }
  ];
  
  constructor (
    private fb: FormBuilder,
    private catalogService: CatalogService,
    private dialogConfig: DynamicDialogConfig
  ) { }

  changeMainForm(frmChild: FormGroup) {
    this.catalogInfoStep.controls['isValid'].setValue(frmChild.valid);
    this.catalogForm = frmChild;

  }

  ngOnInit(): void {

    this.id = this.dialogConfig.data.id;
    this.catalogInfoStep = this.fb.group({
      isValid: ['', Validators.requiredTrue],
    });
    this.checkDifferencesStep = this.fb.group({
      isValid: ['', Validators.requiredTrue],
    });
    this.syncStep = this.fb.group({
      isValid: ['', Validators.requiredTrue],
    });
  }

  checkCatalogForm() {
    this.catalogService.save(this.catalogForm).subscribe((data) => {
      this.catalogForm.get('mainFields').get('id').setValue(data.id);
      this.idCatalog = data.id;
      this.stepWizzard.activeStep = this.stepWizzard.activeStep + 1;
    });
  }

  isPreSync(preSync: boolean) {
    this.preSyncIsValid = preSync;
    this.checkDifferencesStep.controls['isValid'].setValue(preSync);
  }

  goToSync() {
    this.stepWizzard.activeStep = this.stepWizzard.activeStep + 1;
  }

  setCloseForm() {
    this.closeForm.next();
  }

  setSyncFinish() {
    this.syncStep.controls['isValid'].setValue(true);
    this.syncIsValid = true;
  }

  onActiveIndexChange(event: number) {

    this.activeIndex = event;
  }
}
